import { createContext, useContext } from "react";

import type { components } from "../generated/forms-api";

export type DocumentType = components["schemas"]["DocumentType"];

export const DocumentTypesContext = createContext<DocumentType[]>([]);

export const useDocumentTypes = () => useContext(DocumentTypesContext);
